<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Tài Chính</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-tuition-fee-group"
          :label="'Cho phép ' + roleName + ' thiết lập tài chính'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- kỳ đóng -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="summary-period"
          :label="'Cho phép ' + roleName + ' tổng kết kỳ đóng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-period-list"
          :label="'Cho phép ' + roleName + ' xem danh sách kỳ đóng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-is-paid-period"
          :label="'Cho phép ' + roleName + ' xem danh sách học viên thu/chưa thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-note-period"
          :label="'Cho phép ' + roleName + ' thêm ghi chú cho Học viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- nhóm chịu phí -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-tuition-fee-group-list"
          :label="'Cho phép ' + roleName + ' xem danh sách nhóm chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-tuition-fee-group"
          :label="'Cho phép ' + roleName + ' tạo mới nhóm chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-tuition-fee-group-info"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin nhóm chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-tuition-fee-group"
          :label="'Cho phép ' + roleName + ' xóa nhóm chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-student-tuition-fee-group"
          :label="'Cho phép ' + roleName + ' thêm Học viên nhóm chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-student-tuition-fee-group"
          :label="'Cho phép ' + roleName + ' xóa học viên nhóm chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- nhóm giảm trừ -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-priority-group-list"
          :label="'Cho phép ' + roleName + ' xem danh sách nhóm giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-priority-group"
          :label="'Cho phép ' + roleName + ' tạo mới nhóm giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-priority-group-info"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin nhóm giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-priority-group"
          :label="'Cho phép ' + roleName + ' xóa nhóm giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-student-priority-group"
          :label="'Cho phép ' + roleName + ' thêm Học viên nhóm giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-student-priority-group"
          :label="'Cho phép ' + roleName + ' xóa Học viên nhóm giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- khoản phí -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-head-fee-list"
          :label="'Cho phép ' + roleName + ' xem danh sách khoản phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-head-fee"
          :label="'Cho phép ' + roleName + ' tạo mới khoản phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-head-fee"
          :label="'Cho phép ' + roleName + ' xóa khoản phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-head-fee"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin khoản phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-group-head-fee"
          :label="'Cho phép ' + roleName + ' thêm áp dụng khoản phí vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-group-head-fee"
          :label="'Cho phép ' + roleName + ' xóa áp dụng khoản phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-period-head-fee"
          :label="'Cho phép ' + roleName + ' xóa kỳ đóng trong áp dụng chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-period-head-fee"
          :label="'Cho phép ' + roleName + ' thêm kỳ đóng trong áp dụng chịu phí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- giảm trừ -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-dedution-list"
          :label="'Cho phép ' + roleName + ' xem danh sách khoản giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-dedution"
          :label="'Cho phép ' + roleName + ' tạo mới khoản giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-dedution"
          :label="'Cho phép ' + roleName + ' xóa khoản giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-dedution"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin khoản giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-group-dedution"
          :label="'Cho phép ' + roleName + ' thêm áp dụng giảm trừ vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-group-dedution"
          :label="'Cho phép ' + roleName + ' xóa áp dụng khoản giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-period-dedution"
          :label="'Cho phép ' + roleName + ' xóa kỳ đóng trong áp dụng giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-period-dedution"
          :label="'Cho phép ' + roleName + ' thêm kỳ đóng trong áp dụng giảm trừ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- truy thu -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-arrear-fee-list"
          :label="'Cho phép ' + roleName + ' xem danh sách khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-arrear-fee"
          :label="'Cho phép ' + roleName + ' tạo mới khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-arrear-fee"
          :label="'Cho phép ' + roleName + ' xóa khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-arrear-fee"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-group-arrear-fee"
          :label="'Cho phép ' + roleName + ' thêm áp dụng truy thu vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-group-arrear-fee"
          :label="'Cho phép ' + roleName + ' xóa áp dụng khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-period-arrear-fee"
          :label="'Cho phép ' + roleName + ' xóa kỳ đóng trong áp dụng truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-period-arrear-fee"
          :label="'Cho phép ' + roleName + ' thêm kỳ đóng trong áp dụng truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- hoàn trả -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-refund-fee-list"
          :label="'Cho phép ' + roleName + ' xem danh sách khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-refund-fee"
          :label="'Cho phép ' + roleName + ' tạo mới khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-refund-fee"
          :label="'Cho phép ' + roleName + ' xóa khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-refund-fee"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-group-refund-fee"
          :label="'Cho phép ' + roleName + ' thêm áp dụng hoàn trả vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-group-refund-fee"
          :label="'Cho phép ' + roleName + ' xóa áp dụng khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-period-refund-fee"
          :label="'Cho phép ' + roleName + ' xóa kỳ đóng trong áp dụng hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-period-refund-fee"
          :label="'Cho phép ' + roleName + ' thêm kỳ đóng trong áp dụng hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- tài khoản ngân hàng -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-bank-account-list"
          :label="'Cho phép ' + roleName + ' xem danh sách tài khoản ngân hàng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-bank-account"
          :label="'Cho phép ' + roleName + ' sửa thiết lập tài khoản ngân hàng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
